import type { DefaultTheme } from 'styled-components';

import { AzugaTheme } from '@azuga-bms/theme';

import { ACCOUNT_THEME_COLORS } from 'app/constants/accountThemeColors';
import {
  DEFAULT_ACCOUNT_THEME,
  normalizeAccountThemeId,
  type AccountThemeId,
} from 'app/constants/accountThemes';

/**
 * Map portal account theme → ADS styled-components theme.
 * Keeps AzugaTheme typography/neutrals; remaps primary/link/shades to `--app-accent`.
 */
export function buildPortalAdsTheme(
  themeId: string | null | undefined,
): DefaultTheme {
  const id = normalizeAccountThemeId(themeId);
  const palette =
    ACCOUNT_THEME_COLORS[id] ?? ACCOUNT_THEME_COLORS[DEFAULT_ACCOUNT_THEME];
  const base = AzugaTheme as DefaultTheme;
  const baseColors = base.colors;

  return {
    ...base,
    colors: {
      ...baseColors,
      primary: palette.accent,
      primaryHovered: palette.hover,
      primaryActive: palette.hover,
      primarySelected: palette.accent,
      linkPrimary: palette.accent,
      linkHovered: palette.hover,
      primaryShades: {
        ...baseColors.primaryShades,
        100: palette.muted,
        200: palette.muted,
        300: palette.muted,
        400: palette.accent,
        500: palette.accent,
        600: palette.hover,
        700: palette.accent,
        800: palette.hover,
        900: palette.hover,
      },
    },
  };
}

/** Prefer live body class (preview + apply) over Redux when both exist. */
export function resolveActiveAccountThemeId(
  themeColorFromStore?: string | null,
): AccountThemeId {
  if (typeof document !== 'undefined') {
    const fromBody = document.body.dataset.accountTheme;
    if (fromBody) {
      return normalizeAccountThemeId(fromBody);
    }
  }

  return normalizeAccountThemeId(themeColorFromStore);
}
